<template>
    <div class="pm-treatment-history-item" style="border-top: 20px solid #f8f8f8!important;">
        <div class="white" style="padding: 10px 20px 10px 14px; width: 100%; position: relative; display: flex; align-items: stretch; justify-content: center;">

            <div style="flex-grow: 0; border-right: 1px solid #ddd; display: flex; align-items: center; flex-shrink: 0; width: 56px; margin-right: 14px; text-align: left;">
                <mdi style="color: #555;" @click.native="openPdf" v-if="planData.pdfUrl" size="42">mdiFileDocumentOutline</mdi>
                <mdi style="color: #aaa;" v-else size="42">mdiFileOutline</mdi>
            </div>
            <div style="flex-grow: 1;">

                <div style="display: flex; padding: 8px 0px;">
                    <span style="flex-grow: 1; color: #0D47A1;" class="overview--sub-title roboto f13 bold--text">{{ $t('plan_calculator.plan_number', {n: index, }) }} - {{ formattedDate }}</span>
                    <span class="overview--sub-title roboto f13 bold--text">
                        <pm-price class="roboto f13" style="font-weight: 600; color: #0D47A1;" :value="fullTotal" :currency="planData.currency" />
                    </span>
                </div>

                <template v-for="(jaw, index) in ['Upper','Lower']">
                    <div v-if="planData['title' + jaw] !== ''" :key="jaw" style="padding: 5px 0; display: flex; justify-content: center; align-items: center;">
                    <div style="text-align: center; justify-self: center; align-self: center; width: 20px; margin-right: 8px;">
                            <v-icon style="font-size: 20px; transition: all .3s; margin: -8px 0 0 0;" class="black--text" :style="jaw==='Upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                                circle_slice_half
                            </v-icon>
                        </div>
                        <div style="flex-grow: 1">
                            <div style="margin-bottom: 4px;" class="roboto black--text f12">
                                {{ getTitle(jaw, planData['title' + jaw]) }}
                                <!-- szam -->
                            </div>
                        </div>
                        <div style="flex-grow: 0">
                            <pm-price style="color: #7B8088;" class="roboto f12 black--text" :value="planData['total' + jaw]" :currency="planData.currency" />
                        </div>
                    </div>
                </template>

                <template v-if="planData.extraTotal > 0">
                    <div style="padding: 5px 0; display: flex; justify-content: center; align-items: center;">
                    <div style="text-align: center; justify-self: center; align-self: center; width: 20px; margin-right: 8px;">
                            <v-icon style="font-size: 20px; transition: all .3s; margin: -8px 0 0 0;" class="black--text" :style="jaw==='Upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                                circle_slice_both
                            </v-icon>
                        </div>
                        <div style="flex-grow: 1">
                            <div style="margin-bottom: 4px;" class="roboto black--text f12">
                                {{ $t('plan_calculator.extras') }}
                            </div>
                        </div>
                        <div style="flex-grow: 0">
                            <pm-price style="color: #7B8088;" class="roboto f12 black--text" :value="extraTotal" :currency="planData.currency" />
                        </div>
                    </div>
                </template>


                <template v-if="planData.discountAmount && planData.discountAmount > 0">
                    <div style="padding: 5px 0; display: flex; justify-content: center; align-items: center;">
                    <div style="text-align: center; justify-self: center; align-self: center; width: 20px; margin-right: 8px;">
                            <v-icon style="font-size: 20px; transition: all .3s; margin: -8px 0 0 0;" class="black--text" :style="jaw==='Upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                                circle_slice_both
                            </v-icon>
                        </div>
                        <div style="flex-grow: 1">
                            <div style="margin-bottom: 4px;" class="roboto black--text f12">
                                {{ $t('plan_calculator.discount') }}
                            </div>
                        </div>
                        <div style="flex-grow: 0">
                            <span v-if="planData.discountMode === 'percentage'" class="roboto f12 black--text">{{planData.discountAmount}} <small>%</small></span>
                            <pm-price v-else style="color: #7B8088;" class="roboto f12 black--text" :value="planData.discountAmount" :currency="planData.currency" />
                        </div>
                    </div>
                </template>

                <div style="display: flex; border-top: 1px solid #f1f1f1; margin-top: 4px; padding-top: 16px; padding-bottom: 6px; align-items: center; justify-content: flex-end;" >

                    <v-btn class="roboto f13 black--text bold--text" flat style="margin: 0 12px 0 0; height: auto; border: 1px solid #0D47A1 !important; padding: 2px 8px 2px 16px; border-radius: 24px; margin-top: 0px;" @click.stop="$emit('open')">
                        {{ $t('history.load_plan') }}
                        <v-icon style="margin-left: 2px;">
                            chevron_right
                        </v-icon>
                    </v-btn>

                    <v-btn v-if="!showDelete" class="roboto f13 black--text bold--text" flat style="min-width: auto; background: #eee; margin: 0 0 0 4px; height: 30px; width: 30px; border: 0px solid #0D47A1 !important; padding: 4px 2px 4px 8px; border-radius: 24px;" @click.stop="showDelete = true">
                        <v-icon style="margin-right: 8px; font-size: 16px;">
                            close
                        </v-icon>
                    </v-btn>

                    <v-btn v-if="showDelete" class="roboto f13 black--text bold--text" flat style="background: #f00; margin: 0 12px 0 0; height: auto; border: 1px solid #f00 !important; padding: 2px 8px 2px 16px; border-radius: 24px; margin-top: 0px; color: #fff;" @click.stop="$emit('delete')">
                        <span style="color: #fff;">{{ $t('history.delete_plan') }}</span>
                        <v-icon style="margin-left: 2px; color: #fff;">
                            close
                        </v-icon>
                    </v-btn>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";

export default {
    name: "PmPlanHistory",
    props: {
        planData: {
            type: Object,
            default: () => ({}),
        },
        index: {

        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        showDelete: false,
    }),
    computed: {
        extraTotal() {
            return this.planData.extraPercentage ? this.planData.extraTotal + this.planData.extraPercentage : this.planData.extraTotal;
        },
        fullTotal() {
            let total = this.extraTotal + this.planData.totalUpper + this.planData.totalLower;
            if (typeof this.planData.discountAmount !== "undefined") {
                const discountTotal = this.planData.discountMode === "percentage" ? ((parseInt(this.planData.discountAmount)/100) * total): parseInt(this.planData.discountAmount);
                total -= discountTotal;
            }
            return total;
        },
        formattedDate() {
            console.log(this.planData);
            const newDate = new Date();
            newDate.setTime(this.planData.timestamp);
            const dateString = newDate.toLocaleString(this.$store.state.language, {year: "numeric", month: "short", day: "numeric", hour12: false, hour: "2-digit", minute: "2-digit"});
            return dateString;
        },
    },
    methods: {
        openPdf() {
            const params = JSON.parse(JSON.stringify(this.planData));
            params.title = "";
            this.$bus.$emit('openAppDialog', 'pdfViewerGdocs', params);
        },
        getTitle(jaw, defaultTitle) {
            const {lowerTpl, upperTpl} = JSON.parse(this.planData.data);
            let i18nKey = "";

            if (jaw === "Lower" && lowerTpl !== null) {
                i18nKey = `plan_simple.template_${lowerTpl.title}`;
            }

            if (jaw === "Upper" && upperTpl !== null) {
                i18nKey = `plan_simple.template_${upperTpl.title}`;
            }

            return i18nKey ? this.$t(i18nKey) : defaultTitle;
        },
    },
};
</script>
